import React from 'react';
import { Icon } from './Icon.js';
export const IconFilter = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M3 3H21V6L14 13V20L10 21.5V13L3 6L3 3Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", fill: "none" })));
};
//# sourceMappingURL=IconFilter.js.map